// This file is generated by the generate-translations-init.ts script

export function initTranslations() {
  if (typeof window.Drupal !== 'undefined') {
    window.Drupal.t('Show');
    window.Drupal.t('At');
    window.Drupal.t('Map');
    window.Drupal.t('Chart');
    window.Drupal.t('Table');
    window.Drupal.t('In');
    window.Drupal.t('Single');
    window.Drupal.t('Year range');
    window.Drupal.t('Multiple');
    window.Drupal.t('Select years');
    window.Drupal.t(
      'Multiple years & year range selection modes are disabled in this view.'
    );
    window.Drupal.t(
      'Multiple years selection is limited to {limit} years in this view.'
    );
    window.Drupal.t('Top {count}');
    window.Drupal.t('All');
    window.Drupal.t('Clear filters');
    window.Drupal.t('Cancel');
    window.Drupal.t('Apply Selection');
    window.Drupal.t('Select');
    window.Drupal.t('Compare against');
    window.Drupal.t('Add comparison');
    window.Drupal.t('Custom selection of');
    window.Drupal.t('Search');
    window.Drupal.t('Select an option');
    window.Drupal.t('All types');
    window.Drupal.t('types');
    window.Drupal.t('From');
    window.Drupal.t('Source of funding');
    window.Drupal.t('CSV');
    window.Drupal.t('PNG');
    window.Drupal.t('Dashboard Help');
    window.Drupal.t(
      'Download the raw data (CSV) or an image of the displayed chart or map. Use the arrow button to select your preferred download option.\nDo you want to explore more data stories? Click below for a quick guide to help you get the most out of this dashboard.'
    );
    window.Drupal.t('Go to help');
    window.Drupal.t('Close');
    window.Drupal.t('Stock');
    window.Drupal.t('Flow');
    window.Drupal.t('Amount');
    window.Drupal.t('Shares');
    window.Drupal.t('% Growth vs last year');
    window.Drupal.t('Total');
    window.Drupal.t('Handle');
    window.Drupal.t('No data available');
    window.Drupal.t('January');
    window.Drupal.t('Jan');
    window.Drupal.t('February');
    window.Drupal.t('Feb');
    window.Drupal.t('March');
    window.Drupal.t('Mar');
    window.Drupal.t('April');
    window.Drupal.t('Apr');
    window.Drupal.t('May');
    window.Drupal.t('May');
    window.Drupal.t('June');
    window.Drupal.t('Jun');
    window.Drupal.t('July');
    window.Drupal.t('Jul');
    window.Drupal.t('August');
    window.Drupal.t('Aug');
    window.Drupal.t('September');
    window.Drupal.t('Sep');
    window.Drupal.t('October');
    window.Drupal.t('Oct');
    window.Drupal.t('November');
    window.Drupal.t('Nov');
    window.Drupal.t('December');
    window.Drupal.t('Dec');
    window.Drupal.t('Select contextual layer');
    window.Drupal.t('No contextual layer');
    window.Drupal.t('By');
    window.Drupal.t('Level');
    window.Drupal.t('Category');
    window.Drupal.t('Source of funding');
    window.Drupal.t('Year');
    window.Drupal.t('Month');
    window.Drupal.t('Total');
    window.Drupal.t('View absolute');
    window.Drupal.t('View share');
    window.Drupal.t('View % of growth vs last year');
    window.Drupal.t('vs. previous year');
    window.Drupal.t('Lower');
    window.Drupal.t('Higher');
    window.Drupal.t('% Growth vs last year');
    window.Drupal.t('Open {levelName} page');
    window.Drupal.t('Planning, funding and results dashboard');
  }
}
